import { CSSProperties } from "react";
import { BasicUserInfoResponseType } from "../../../api";
import IconHinweis from "../svgs/IconHinweis";

interface PropsHinweis {
  title?: string;
  link?: string;
  message: string;
  marginBottom?: boolean;
  style?: CSSProperties;
  userInfo?: BasicUserInfoResponseType;
  danger?: boolean;
}

export function Hinweis(options: PropsHinweis) {
  const innerContainer = (
    <div
      className={
        "alert alert-box border-0 rounded-0 bg--peach-secondary" + (options.danger ? " alert-danger" : " alert-info") + (options.marginBottom ? " mb-5" : "")
      }
      role="alert"
      data-gtm-box="Hinweis"
    >
      <div className="alert-info-bulb">
        <IconHinweis style={options.style} />
        <span>{options.danger ? "Warnung" : "Hinweis"}</span>
      </div>
      <div className="alert-info-content">
        {options.title && <p className="title">{options.title}</p>}
        <p dangerouslySetInnerHTML={{ __html: options.message }}></p>
      </div>
    </div>
  );

  return (
    <>
      {(options.link &&
        options.userInfo &&
        (!!options.userInfo.kammermitgliedschaft || options.userInfo.authenticatedUserMemberId === "0") && (
          <a href={options.link} style={{ textDecoration: "none" }}>
            {innerContainer}
          </a>
        )) || <>{innerContainer}</>}
    </>
  );
}

export function NBWBHinweisBerechtigungen() {
  return <Hinweis message="Wählen Sie eine oder mehrere Berechtigungen, um Ihre Auswahl weiter einzuschränken" />;
}

export function NBWBHinweisBestaetigung() {
  return (
    <Hinweis
      message="Die Bestätigung wird als PDF-Dokument erstellt und an Ihr WKO-Postfach zugestellt."
      marginBottom={true}
    />
  );
}

export function StammblattHinweisBestaetigung() {
  return (
    <Hinweis message="Die Bestätigung wird als PDF-Dokument erstellt und an Ihr WKO-Postfach zugestellt. Sie können es zusätzlich an eine beliebige E-Mail senden." />
  );
}
